export interface ComicChapter {
  id: number;
  title: string;
  updateDate: string;
}

export interface Comic {
  id: number;
  title: string;
  originalTitle: string;
  author: string;
  coverImage: string;
  categories: string[];
  description: string;
  status: string;
  rating: number;
  viewCount: number;
  updateDate: string;
  chapters: ComicChapter[];
  tags: string[];
  featured?: boolean;
  isNew?: boolean;
  isHot?: boolean;
}

export const comics: Comic[] = [
  {
    id: 1,
    title: '我的野蛮王妃',
    originalTitle: '궁',
    author: '朴素熙',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20princess%20in%20traditional%20hanbok%20dress%20with%20modern%20twist%2C%20elegant%20palace%20background%2C%20soft%20romantic%20lighting%2C%20warm%20pink%20and%20gold%20tones%2C%20clean%20simple%20background%2C%20high%20quality%20digital%20art%2C%20detailed%20character%20design%2C%20manhwa%20webtoon%20cover%20style&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    categories: ['lianai', 'rexiao'],
    description: '在现代韩国，王室依然存在。普通女高中生申彩静因祖父与先皇的约定，不得不嫁给皇太子李信，从此开始了既甜蜜又痛苦的宫中生活。面对冷漠的丈夫、热情的皇子李律，以及复杂的宫廷斗争，彩静能否找到属于自己的幸福？这是一部融合了宫廷、爱情与成长的经典韩漫作品，画风精致，情节引人入胜。',
    status: '已完结',
    rating: 9.2,
    viewCount: 1280000,
    updateDate: '2026-07-28',
    chapters: [
      { id: 1, title: '第1话 命运的婚约', updateDate: '2025-01-15' },
      { id: 2, title: '第2话 初入宫中', updateDate: '2025-01-22' },
      { id: 3, title: '第3话 皇太子殿下', updateDate: '2025-01-29' },
      { id: 4, title: '第4话 宫中的规矩', updateDate: '2025-02-05' },
      { id: 5, title: '第5话 不速之客', updateDate: '2025-02-12' },
    ],
    tags: ['宫廷', '恋爱', '成长', '经典'],
    featured: true,
  },
  {
    id: 2,
    title: '深渊之主',
    originalTitle: '심연의 지배자',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20manhwa%20cover%20featuring%20a%20mysterious%20warrior%20with%20glowing%20purple%20eyes%20holding%20a%20crystal%20sword%2C%20dark%20abyss%20background%20with%20floating%20crystals%2C%20dramatic%20lighting%2C%20epic%20atmosphere%2C%20clean%20simple%20composition%2C%20high%20quality%20digital%20art%20in%20manhwa%20style&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    categories: ['qihuan', 'dongzuo', 'rexiao'],
    description: '当世界被深渊吞噬，人类最后的希望寄托在一位被遗忘的英雄身上。觉醒神秘力量后，他踏上了一条充满危险与奇迹的冒险之路，探索深渊的真相，与强大的敌人战斗，拯救濒临毁灭的世界。',
    status: '连载中',
    rating: 9.5,
    viewCount: 2560000,
    updateDate: '2026-08-02',
    chapters: [
      { id: 1, title: '第1话 深渊降临', updateDate: '2026-01-10' },
      { id: 2, title: '第2话 觉醒之力', updateDate: '2026-01-17' },
      { id: 3, title: '第3话 第一场战斗', updateDate: '2026-01-24' },
      { id: 4, title: '第4话 同伴相遇', updateDate: '2026-02-01' },
    ],
    tags: ['奇幻', '冒险', '战斗', '热血'],
    featured: true,
    isHot: true,
  },
  {
    id: 3,
    title: '甜蜜陷阱',
    originalTitle: '달콤한 함정',
    author: '李恩珠',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20comedy%20manhwa%20cover%20of%20a%20young%20couple%20sharing%20a%20sweet%20moment%20in%20a%20cozy%20cafe%2C%20pastel%20pink%20and%20cream%20color%20palette%2C%20soft%20warm%20lighting%2C%20cute%20art%20style%2C%20clean%20simple%20background%2C%20high%20quality%20digital%20illustration%2C%20romantic%20atmosphere&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    categories: ['lianai', 'gaoxiao', 'rexiao'],
    description: '职场精英金智秀意外卷入一场精心设计的甜蜜陷阱，霸道总裁与甜美设计师的办公室恋情就此展开。笑料百出的日常，令人心动的瞬间，这是一部让你笑着看完的浪漫喜剧。',
    status: '连载中',
    rating: 8.8,
    viewCount: 1890000,
    updateDate: '2026-08-01',
    chapters: [
      { id: 1, title: '第1话 新来的设计师', updateDate: '2026-03-01' },
      { id: 2, title: '第2话 意外之吻', updateDate: '2026-03-08' },
      { id: 3, title: '第3话 总裁的秘密', updateDate: '2026-03-15' },
    ],
    tags: ['恋爱', '甜宠', '职场', '喜剧'],
    isHot: true,
  },
  {
    id: 4,
    title: '暗夜追踪者',
    originalTitle: '밤의 추적자',
    author: '崔敏浩',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20thriller%20mystery%20manhwa%20cover%20with%20a%20detective%20silhouette%20in%20a%20dark%20alley%20illuminated%20by%20street%20lamps%2C%20rainy%20night%20atmosphere%2C%20noir%20style%2C%20suspenseful%20mood%2C%20clean%20simple%20composition%2C%20high%20quality%20digital%20art%2C%20dramatic%20shadows&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    categories: ['xuanyi', 'dongzuo', 'rexiao'],
    description: '首尔夜晚的街头上，一系列离奇案件接连发生。天才侦探朴志勋与女刑警韩素希联手追查真相，却发现自己正陷入一个惊天阴谋之中。每一条线索都指向更深的黑暗，他们能否在凶手下一次行动前抓住真凶？',
    status: '连载中',
    rating: 9.0,
    viewCount: 1560000,
    updateDate: '2026-07-30',
    chapters: [
      { id: 1, title: '第1话 深夜的报警电话', updateDate: '2026-04-05' },
      { id: 2, title: '第2话 第一具尸体', updateDate: '2026-04-12' },
      { id: 3, title: '第3话 迷雾重重', updateDate: '2026-04-19' },
      { id: 4, title: '第4话 意外证人', updateDate: '2026-04-26' },
    ],
    tags: ['悬疑', '推理', '犯罪', '都市'],
    isHot: true,
  },
  {
    id: 5,
    title: '剑魂',
    originalTitle: '검혼',
    author: '张赫',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20action%20martial%20arts%20manhwa%20cover%20with%20a%20swordsman%20in%20traditional%20Korean%20warrior%20attire%2C%20dynamic%20action%20pose%20with%20sword%2C%20wind%20and%20cherry%20blossom%20petals%2C%20dramatic%20lighting%2C%20clean%20simple%20background%2C%20high%20quality%20digital%20art%20in%20manhwa%20style&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    categories: ['dongzuo', 'qihuan'],
    description: '在一个以剑为尊的世界里，孤儿少年韩云从零开始，凭借天赋与毅力一步步踏上剑道巅峰。古老的剑术传承、神秘的剑魂觉醒、强大的对手挑战，这是一部热血沸腾的剑客传奇。',
    status: '连载中',
    rating: 9.1,
    viewCount: 2100000,
    updateDate: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 铁匠铺里的少年', updateDate: '2026-02-14' },
      { id: 2, title: '第2话 第一次握剑', updateDate: '2026-02-21' },
      { id: 3, title: '第3话 剑术入门', updateDate: '2026-02-28' },
    ],
    tags: ['动作', '武侠', '热血', '成长'],
  },
  {
    id: 6,
    title: '搞笑一家人',
    originalTitle: '웃긴 가족',
    author: '孙艺娜',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20comedy%20slice%20of%20life%20manhwa%20cover%20showing%20a%20quirky%20Korean%20family%20gathered%20in%20a%20living%20room%2C%20funny%20expressions%2C%20bright%20and%20colorful%20style%2C%20warm%20happy%20atmosphere%2C%20clean%20simple%20background%2C%20high%20quality%20digital%20illustration&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    categories: ['gaoxiao', 'lianai'],
    description: '这是一个关于一个超级搞笑家庭的日常故事！从爱唠叨的妈妈、沉默寡言的爸爸，到调皮捣蛋的兄妹俩，每一天都充满了意想不到的笑料和温暖。让你在笑声中感受家的温暖。',
    status: '连载中',
    rating: 8.5,
    viewCount: 980000,
    updateDate: '2026-08-01',
    chapters: [
      { id: 1, title: '第1话 今天开始记录', updateDate: '2026-05-01' },
      { id: 2, title: '第2话 妈妈的秘密食谱', updateDate: '2026-05-08' },
      { id: 3, title: '第3话 爸爸的尴尬时刻', updateDate: '2026-05-15' },
    ],
    tags: ['搞笑', '家庭', '日常', '温馨'],
  },
  {
    id: 7,
    title: '月光之恋',
    originalTitle: '달빛 연가',
    author: '高允儿',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20romantic%20BL%20manhwa%20cover%20with%20two%20handsome%20young%20men%20under%20moonlight%2C%20gentle%20atmosphere%2C%20soft%20blue%20and%20silver%20tones%2C%20dreamy%20night%20scene%2C%20clean%20simple%20background%2C%20high%20quality%20digital%20illustration%2C%20tender%20romantic%20mood&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    categories: ['danmei', 'lianai'],
    description: '在月光照耀的夜晚，两个彼此吸引的灵魂相遇了。一个是在校大学生，一个是新锐音乐家，他们在命运的安排下相识相知，展开一段温柔而深情的浪漫故事。画风唯美，情感细腻。',
    status: '连载中',
    rating: 9.3,
    viewCount: 1750000,
    updateDate: '2026-08-02',
    chapters: [
      { id: 1, title: '第1话 月下的初遇', updateDate: '2026-04-18' },
      { id: 2, title: '第2话 音符中的心意', updateDate: '2026-04-25' },
      { id: 3, title: '第3话 靠近的心', updateDate: '2026-05-02' },
    ],
    tags: ['耽美', '恋爱', '音乐', '校园'],
  },
  {
    id: 8,
    title: '鬼楼',
    originalTitle: '귀루',
    author: '李浩俊',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20horror%20manhwa%20cover%20showing%20an%20abandoned%20apartment%20building%20at%20night%20with%20one%20lit%20window%2C%20eerie%20atmosphere%2C%20dark%20shadows%2C%20foggy%20surroundings%2C%20creepy%20mood%2C%20clean%20simple%20composition%2C%20high%20quality%20digital%20art%2C%20horror%20thriller%20style&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    categories: ['kongbu', 'xuanyi'],
    description: '一栋被诅咒的公寓楼里，流传着无数恐怖的传说。六个互不相识的人因为各自的理由搬入这栋鬼楼，诡异的事件接连发生。他们必须面对自己内心最深的恐惧，揭开鬼楼背后的恐怖真相。',
    status: '已完结',
    rating: 8.7,
    viewCount: 1320000,
    updateDate: '2026-06-15',
    chapters: [
      { id: 1, title: '第1话 新住户', updateDate: '2025-09-01' },
      { id: 2, title: '第2话 午夜脚步声', updateDate: '2025-09-08' },
      { id: 3, title: '第3话 405号房的秘密', updateDate: '2025-09-15' },
      { id: 4, title: '第4话 镜中的脸', updateDate: '2025-09-22' },
    ],
    tags: ['恐怖', '惊悚', '都市传说', '悬疑'],
  },
  {
    id: 9,
    title: '异世界便利店',
    originalTitle: '이세계 편의점',
    author: '金瑞英',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20fantasy%20comedy%20manhwa%20cover%20of%20a%20convenience%20store%20in%20a%20magical%20fantasy%20world%2C%20elves%20and%20monsters%20shopping%2C%20bright%20colorful%20style%2C%20fun%20whimsical%20atmosphere%2C%20clean%20simple%20background%2C%20high%20quality%20digital%20illustration&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    categories: ['qihuan', 'gaoxiao'],
    description: '平凡便利店店员李正宇一觉醒来，发现自己的便利店开在了异世界！精灵、兽人、魔族都成了他的顾客。在这奇妙的世界里，一罐可乐可能比魔法药水更珍贵，一个饭团能拯救一个王国！',
    status: '连载中',
    rating: 8.9,
    viewCount: 1680000,
    updateDate: '2026-07-31',
    chapters: [
      { id: 1, title: '第1话 开门就是异世界', updateDate: '2026-02-28' },
      { id: 2, title: '第2话 第一个异世界顾客', updateDate: '2026-03-07' },
      { id: 3, title: '第3话 方便面的魔力', updateDate: '2026-03-14' },
    ],
    tags: ['奇幻', '搞笑', '异世界', '日常'],
  },
  {
    id: 10,
    title: '契约婚姻',
    originalTitle: '계약 결혼',
    author: '韩智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20romantic%20drama%20manhwa%20cover%20of%20a%20couple%20in%20wedding%20attire%20with%20tense%20expressions%2C%20luxurious%20mansion%20background%2C%20dramatic%20lighting%2C%20elegant%20style%2C%20clean%20simple%20composition%2C%20high%20quality%20digital%20art%2C%20romantic%20but%20melancholy%20mood&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    categories: ['lianai', 'rexiao'],
    description: '为了挽救家族企业，财阀千金崔秀雅与冷酷总裁郑道贤签订了一份为期三年的婚姻契约。表面上是一场交易，内心却渐渐萌生了真情。当契约到期，他们会选择离开，还是承认这份超越契约的爱情？',
    status: '已完结',
    rating: 9.0,
    viewCount: 1980000,
    updateDate: '2026-07-20',
    chapters: [
      { id: 1, title: '第1话 破产边缘', updateDate: '2025-06-15' },
      { id: 2, title: '第2话 意外的求婚', updateDate: '2025-06-22' },
      { id: 3, title: '第3话 契约条款', updateDate: '2025-06-29' },
    ],
    tags: ['恋爱', '契约', '财阀', '甜虐'],
    isNew: true,
  },
  {
    id: 11,
    title: '灭世魔法师',
    originalTitle: '멸망의 마법사',
    author: '吴世勋',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20epic%20fantasy%20manhwa%20cover%20with%20a%20powerful%20mage%20casting%20a%20massive%20fire%20spell%2C%20ruins%20and%20dragons%20in%20background%2C%20dramatic%20apocalyptic%20scene%2C%20intense%20colors%2C%20clean%20composition%2C%20high%20quality%20digital%20art%20in%20manhwa%20style&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    categories: ['qihuan', 'dongzuo'],
    description: '被世人畏惧的灭世魔法师凯尔，实际上只是一个想过平静生活的宅男。然而，当世界面临真正的危机时，他不得不再次展露他那毁天灭地的力量。轻松搞笑与热血战斗并存。',
    status: '连载中',
    rating: 9.4,
    viewCount: 2340000,
    updateDate: '2026-08-03',
    chapters: [
      { id: 1, title: '第1话 最强魔法师的退休生活', updateDate: '2026-01-05' },
      { id: 2, title: '第2话 不请自来的访客', updateDate: '2026-01-12' },
      { id: 3, title: '第3话 王国的召唤', updateDate: '2026-01-19' },
    ],
    tags: ['奇幻', '魔法', '搞笑', '热血'],
    isNew: true,
    featured: true,
  },
  {
    id: 12,
    title: '秘密花园',
    originalTitle: '비밀의 화원',
    author: '安美善',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20mysterious%20romantic%20manhwa%20cover%20with%20a%20beautiful%20woman%20in%20a%20secret%20garden%20full%20of%20glowing%20flowers%2C%20dreamy%20atmosphere%2C%20soft%20pastel%20colors%2C%20magical%20glow%20effects%2C%20clean%20simple%20background%2C%20high%20quality%20digital%20illustration&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    categories: ['lianai', 'xuanyi'],
    description: '在一座古老庄园的秘密花园中，女主角发现了通往另一个时空的入口。在那里，她遇见了一个来自过去的男子，展开一段跨越时空的浪漫与冒险。真相与爱情交织的奇幻故事。',
    status: '连载中',
    rating: 8.6,
    viewCount: 1120000,
    updateDate: '2026-07-29',
    chapters: [
      { id: 1, title: '第1话 搬进老宅', updateDate: '2026-05-20' },
      { id: 2, title: '第2话 花园里的门', updateDate: '2026-05-27' },
      { id: 3, title: '第3话 时空旅行者', updateDate: '2026-06-03' },
    ],
    tags: ['恋爱', '奇幻', '时空', '悬疑'],
    isNew: true,
  },
];

export const getComicById = (id: number): Comic | undefined => {
  return comics.find((comic) => comic.id === id);
};

export const getComicsByCategory = (slug: string): Comic[] => {
  if (slug === 'rexiao') {
    return [...comics]
      .sort((a, b) => b.viewCount - a.viewCount)
      .slice(0, 8);
  }
  if (slug === 'xinzuo') {
    return comics.filter((comic) => comic.isNew);
  }
  return comics.filter((comic) => comic.categories.includes(slug));
};

export const getFeaturedComics = (): Comic[] => {
  return comics.filter((comic) => comic.featured);
};

export const getHotComics = (): Comic[] => {
  return comics.filter((comic) => comic.isHot);
};

export const getNewComics = (): Comic[] => {
  return comics.filter((comic) => comic.isNew);
};

export const getLatestUpdates = (): Comic[] => {
  return [...comics].sort(
    (a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime()
  );
};

export const getRelatedComics = (comic: Comic, limit: number = 4): Comic[] => {
  return comics
    .filter((c) => c.id !== comic.id && c.categories.some((cat) => comic.categories.includes(cat)))
    .slice(0, limit);
};